export enum IssuesColumnsIdEnum {
    DESCRIPTION = "description",
    DUE_DATE = "due_date",
    STATUS = "status",
    OWNER = "owner",
    NUMBER = "number",
}
